"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.prefix = exports.classNameMappings = void 0;

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _utils = require("reactstrap/lib/utils");

var _styles = _interopRequireDefault(require("./styles"));

var prefix = "oui-";
exports.prefix = prefix;
var classNameMappings = (0, _reduce["default"])(_styles["default"]).call(_styles["default"], function (mapper, cls) {
  mapper[cls] = prefix + cls;
  return mapper;
}, {});
exports.classNameMappings = classNameMappings;
(0, _utils.setGlobalCssModule)(classNameMappings);